import { createApp } from 'vue'

import App from './App.vue'
import '@/common/reset.scss'
import '@/common/px2rem'
import './style.css'
import request from '@/config/request'
import utils from '@/utils/index'
import api from '@/api/index'
import router from './router'
import i18n, { $t } from '@/i18n/index'
import VConsole from 'vconsole'

// 在开发测试环境中启用 VConsole
// if (process.env.NODE_ENV === 'development') {
// new VConsole()
// }

const app = createApp(App)
app.use(router)
app.use(i18n)
app.config.globalProperties.$request = request // 自定义全局添加
app.config.globalProperties.$utils = utils // 自定义全局添加
app.config.globalProperties.$api = api // 自定义全局添加
app.config.globalProperties.$t = $t
app.mount('#app')
